import React, { useContext, useState } from 'react';
import "./StudentsAndTeachers.scss";
import { studentParentFields } from "./StudentsAndParents.js";
import InputBox from '../../components/Fields/Input Box/InputBox.jsx';
import RadioBtn from '../../components/Fields/Radio Button/RadioBtn';
import { BsCloudUpload } from "react-icons/bs";
import { styles, inputStyles, radioStyles, labelStyles, optionStyles } from './StudentParentFields.js';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useRef } from 'react';
import "../../components/Fields/Upload Button/UploadFile.scss"
import { FileUpload } from 'primereact/fileupload';
import { useEffect } from 'react'; import { AppContext } from '../../context/AppContext.jsx';
import { Dropdown } from 'primereact/dropdown';
import SuccessDialog from '../../components/SuccessDialog.jsx';
import { IoIosCloseCircleOutline } from "react-icons/io";

const StudentsAndParents = () => {

    const { backendUrl } = useContext(AppContext)
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [studentParentData, setStudentParentData] = useState(
        studentParentFields.reduce((acc, field) => {
            acc[field.fieldName] = "";
            return acc;
        }, {})
    );
    const [selectedFiles, setSelectedFiles] = useState({});
    const fileUploadRefs = useRef({});
    useEffect(() => {
        studentParentFields.forEach((field) => {
            if (field.type === "file") {
                fileUploadRefs.current[field.fieldName] = React.createRef();
            }
        });
    }, []);

    const handleFileSelect = (fieldName, e) => {
        const file = e.files[0];
        if (file) {
            handleChange(fieldName, file);
            setSelectedFiles(prev => ({
                ...prev,
                [fieldName]: file
            }));
        }
    };

    const handleChange = (fieldName, value) => {
        setStudentParentData((prevState) => ({
            ...prevState,
            [fieldName]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: ""
        }));
    };

    const programmes = [
        { name: "B.Sc Biotechnology" },
        { name: "B.Sc Hotel Management & Catering Science" },
        { name: "BBA (*AICTE)" },
        { name: "B.C.A (*AICTE)" },
        { name: "B.Sc Computer Science" },
        { name: "B.Sc Information Technology" },
        { name: "B.Sc Nutrition & Dietetics" },
        { name: "B.A English" },
        { name: "B.Com" },
        { name: "Ai and data science" },
        { name: "B.Sc Microbiology" },
        { name: "B.Sc Visual Communication" },
        { name: "M.Sc Biotechnology" },
        { name: "M.Sc Computer Science" },
        { name: "M.Sc Mathematics" },
        { name: "M.A English" },
        { name: "M.Com" },
    ];

    const [errors, setErrors] = useState({})
    const eMailpattern = /.+@.+\..+/
    const phoneNumberPattern = /^\d{10}$/
    const academicPattern = /^\d{4}-\d{4}$/



    const validateForm = () => {
        const testeMailpattern = eMailpattern.test(studentParentData.email);
        const testcontactNumberParentPattern = phoneNumberPattern.test(studentParentData.contactNumberParent);
        const testcontactNumberStudentPattern = phoneNumberPattern.test(studentParentData.contactNumberStudent);
        const currentyear = new Date().getFullYear();
        let startYear, endYear;
        const rawInput = studentParentData.academicPeriod || "";
        const cleanedAcademicPeriod = rawInput.trim().replace(/\s+/g, '');
        const testacademicYearPattern = academicPattern.test(cleanedAcademicPeriod);
        const error = {};
        if (!studentParentData.role) {
            error.role = "Required"
        }
        if (!studentParentData.studentName) {
            error.studentName = "Required"
        }
        if (!studentParentData.department) {
            error.department = "Required"
        }
        if (!studentParentData.parentName) {
            error.parentName = "Required"
        }
        if (!cleanedAcademicPeriod) {
            error.academicPeriod = "Required";
        } else if (!testacademicYearPattern) {
            error.academicPeriod = "Invalid format. Use YYYY-YYYY (e.g., 2012-2018)";
        } else {
            [startYear, endYear] = cleanedAcademicPeriod.split("-").map(Number);

            if (isNaN(startYear) || isNaN(endYear)) {
                error.academicPeriod = "Start and end years must be valid numbers";
            } else if (startYear >= endYear) {
                error.academicPeriod = "Start year must be less than end year";
            } else if (startYear < 2001 || endYear < 2001) {
                error.academicPeriod = "Years should not be less than 2001";
            } else if (startYear > currentyear || endYear > currentyear) {
                error.academicPeriod = `Years should not exceed ${currentyear}`;
            }
        }
        if (!studentParentData.year) {
            error.year = "Required"
        }
        if (!studentParentData.residentialAddress) {
            error.residentialAddress = "Required"
        }
        if (!studentParentData.contactNumberStudent) {
            error.contactNumberStudent = "Required"
        }
        else if (!testcontactNumberStudentPattern) {
            error.contactNumberStudent = "Enter 10 digit number"
        }
        if (!studentParentData.contactNumberParent) {
            error.contactNumberParent = "Required"
        }
        else if (!testcontactNumberParentPattern) {
            error.contactNumberParent = "Enter 10 digit number"
        }
        if (!studentParentData.email) {
            error.email = "Required"
        }
        else if (!testeMailpattern) {
            error.email = "Invalid Pattern"
        }
        if (!studentParentData.universityRegNumber) {
            error.universityRegNumber = "Required"
        }
        if (!studentParentData.idProof) {
            error.idProof = "Required"
        }
        if (!studentParentData.grievance) {
            error.grievance = "Required"
        }
        if (!studentParentData.grievanceProof) {
            error.grievanceProof = "Required"
        }
        setErrors(error)
        return Object.keys(errors).length === 0;
    }

    const clearForm = () => {
        setStudentParentData(
            studentParentFields.reduce((acc, field) => {
                acc[field.fieldName] = field.type === "file" ? null : "";
                return acc;
            }, {})
        );
        setSelectedFiles({});
        Object.keys(fileUploadRefs.current).forEach((key) => {
            if (fileUploadRefs.current[key].current) {
                fileUploadRefs.current[key].current.clear();
            }
        });
        setErrors({});
    }

    const uploadStudentParentGrievanceData = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            try {
                setIsSubmitting(true);
                const formData = new FormData();
                for (let key in studentParentData) {
                    if (studentParentData[key]) {
                        formData.append(key, studentParentData[key]);
                    }
                }
                const res = await axios.post(
                    `${backendUrl}/api/auth/uploadStudentParentGrievance`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                if (res.data.success === true) {
                    setShowSuccessDialog(true);
                    clearForm();
                }
            }
            catch (error) {
                console.error('Error fetching users:', error);
                if (error.response && error.response.status === 503) {
                    toast.error("⚠️ The service is currently under maintenance. Please try again later.");
                }
                else if (!navigator.onLine) {
                    toast.error("🚫 No internet connection. Please check your network.");
                }
                else if (error.request && !error.response) {
                    toast.error("⚠️ Network issue or server is unreachable. Try again later.")
                }
                else if (error.response && error.response.status === 400) {
                    console.error(error.response.data.message)
                }
                else {
                    console.error("Unexpected error:", error);
                    toast.error("Something went wrong.");
                }
            } finally {
                setIsSubmitting(false);
            }
        }
    };

    const firstColumnFields = studentParentFields.slice(0, 9);
    const secondColumnFields = studentParentFields.slice(9);

    const handleRemove = (fieldName) => {
        fileUploadRefs.current[fieldName]?.current?.clear();
        setSelectedFiles(prev => {
            const updated = { ...prev };
            delete updated[fieldName];
            return updated;
        });
        setStudentParentData(prev => ({
            ...prev,
            [fieldName]: null
        }));
    };


    return (
        <div className="studentsAndTeachersMainContainer">

            <SuccessDialog
                visible={showSuccessDialog}
                onHide={() => setShowSuccessDialog(false)}
                header="Request Submitted"
                message="Your request has been submitted successfully!"
                buttonLabel="OK"
            />

            <form action="" className="formContainer" onSubmit={uploadStudentParentGrievanceData}>
                <div className="form-grid">
                    <div className="form-first-column">
                        {firstColumnFields.map((field, index) => (
                            <div key={index} className={`form-field ${field.className || ""}`}>
                                {(field.type === "text" || field.type === "email") && field.fieldName !== "department" ? (
                                    <InputBox
                                        fieldName={field.fieldName}
                                        fieldType={field.type}
                                        placeholder={field.placeholder}
                                        styles={styles}
                                        inputStyles={inputStyles}
                                        labelStyles={labelStyles}
                                        customLabelName={field.customLabelName}
                                        required={field.required}
                                        value={studentParentData[field.fieldName]}
                                        handleChange={(e) => handleChange(field.fieldName, e.target.value)}
                                        hasError={!!errors[field.fieldName]}
                                        keyFilter={field.keyFilter}
                                        maxLength={field.maxLength}
                                    />

                                ) : field.type === "radio" ? (
                                    <RadioBtn
                                        fieldName={field.fieldName}
                                        fieldType={field.type}
                                        options={field.options}
                                        styles={styles}
                                        optionStyles={optionStyles}
                                        labelStyles={labelStyles}
                                        radioStyles={radioStyles}
                                        customLabelName={field.customLabelName}
                                        required={field.required}
                                        selectedValue={studentParentData[field.fieldName]}
                                        handleChange={(newValue) => handleChange(field.fieldName, newValue)}
                                        hasError={!!errors[field.fieldName]}
                                    />
                                )
                                    :
                                    field.fieldName === "department" && field.type === "text" ? (
                                        <div style={styles} className='department-dropdown'>
                                            <label htmlFor={field.fieldName} style={labelStyles}>
                                                {field.customLabelName}
                                                {field.required && <sup style={{ fontWeight: "700", color: "red", fontSize: "1.3rem" }}>*</sup>}
                                            </label>
                                            <Dropdown
                                                fieldName={field.fieldName}
                                                fieldType={field.type}
                                                placeholder={field.placeholder}
                                                styles={styles}
                                                options={programmes}
                                                optionLabel="name"
                                                checkmark={false}
                                                highlightOnSelect={false}
                                                inputStyles={inputStyles}
                                                labelStyles={labelStyles}
                                                customLabelName={field.customLabelName}
                                                value={programmes.find(p => p.name === studentParentData[field.fieldName])}
                                                onChange={(e) => handleChange(field.fieldName, e.value.name)}
                                                hasError={!!errors[field.fieldName]}
                                            />
                                        </div>
                                    ) : null}

                                {errors[field.fieldName] && (
                                    <p className="error-message">{errors[field.fieldName]}</p>
                                )}
                            </div>

                        ))}
                    </div>

                    <div className="form-second-column">
                        {secondColumnFields.map((field, index) => (
                            <div key={index} className={`form-field ${field.className || ""}`}>
                                {field.type === "text" || field.type === "email" ? (
                                    <InputBox
                                        fieldName={field.fieldName}
                                        fieldType={field.type}
                                        placeholder={field.placeholder}
                                        styles={styles}
                                        inputStyles={inputStyles}
                                        labelStyles={labelStyles}
                                        customLabelName={field.customLabelName}
                                        required={field.required}
                                        value={studentParentData[field.fieldName]}
                                        handleChange={(e) => handleChange(field.fieldName, e.target.value)}
                                        hasError={!!errors[field.fieldName]}
                                    />
                                ) : field.type === "radio" ? (
                                    <RadioBtn
                                        fieldName={field.fieldName}
                                        fieldType={field.type}
                                        options={field.options}
                                        styles={styles}
                                        labelStyles={labelStyles}
                                        radioStyles={radioStyles}
                                        customLabelName={field.customLabelName}
                                        required={field.required}
                                        selectedValue={studentParentData[field.fieldName]}
                                        handleChange={(newValue) => handleChange(field.fieldName, newValue)}
                                        hasError={!!errors[field.fieldName]}
                                    />
                                ) : field.type === "file" ? (

                                    <div style={styles} className="uploadFileContainer">
                                        <label htmlFor={field.fieldName}
                                            className="label"
                                            style={labelStyles}>
                                            {field.customLabelName}
                                            {field.required && <sup style={{ fontWeight: "700", color: "red", fontSize: "1.3rem" }}>*</sup>}
                                        </label>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "10px", backgroundColor: "white", borderRadius: "5px", padding: "clamp(20px, 4vw, 35px) 2px", fontFamily: "var(--font-paragraph)" }}>
                                            <div><BsCloudUpload size={26} /></div>
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "5px", fontWeight: "600", fontFamily: "var(--font-paragraph)" }}>
                                                <div style={{ textAlign: "center" }}>Upload 1 Supported File</div>
                                                <div style={{ color: "#7f7f7f", textAlign: "center" }}>PDF, Document or Image. Max 10 MB</div>
                                            </div>
                                            <div style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px",
                                            }}>
                                                <FileUpload
                                                    name={field.fieldName}
                                                    mode='basic'
                                                    accept="image/*, .pdf,.doc,.docx,.xls,.xlsx"
                                                    auto={false}
                                                    onSelect={(e) => handleFileSelect(field.fieldName, e)}
                                                    style={inputStyles}
                                                    ref={fileUploadRefs.current[field.fieldName]}
                                                    className={errors[field.fieldName] ? 'p-invalid' : ''}
                                                    chooseLabel="Browse File"
                                                />
                                                {selectedFiles[field.fieldName] && (
                                                    <div style={{
                                                        marginLeft: '-20px',
                                                        marginBottom: '40px',
                                                        cursor: "pointer",
                                                        color: "red",
                                                        zIndex: 20
                                                    }}>
                                                        <IoIosCloseCircleOutline
                                                            size={18}
                                                            style={{ cursor: "pointer", color: "#d32f2f" }}
                                                            onClick={() => {
                                                                fileUploadRefs.current[field.fieldName]?.current?.clear();
                                                                handleRemove(field.fieldName);
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                                {errors[field.fieldName] && (
                                    <p className="error-message">{errors[field.fieldName]}</p>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        style={{ backgroundColor: "#0D553A", border: "none", color: "white", padding: "clamp(10px, 1.2vw, 13px) clamp(25px, 3vw, 39px)", borderRadius: "8px", cursor: "pointer", fontFamily: "var(--font-submit-button)", fontSize: "var(--font-submit-button-size)" }}>
                        {isSubmitting ? (
                            <>
                                <i className="pi pi-spin pi-spinner" style={{ marginRight: '8px' }}></i>
                                Submitting...
                            </>
                        ) : (
                            "Submit"
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default StudentsAndParents;
